import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('../views/Ja.vue'),
    children: [
      {
        path: '',
        name: 'ja/home',
        component: Home,
      },
      {
        path: 'index/:id',
        name: 'ja/index_sub',
        component: () => import('../views/Index.vue'),
        props: route => ({
          id: String(route.params.id)
        })
      },
      {
        path: 'search',
        name: 'ja/search',
        component: () => import('../views/Search.vue'),
      },
      {
        path: 'detail/:id',
        name: 'ja/detail',
        component: () => import('../views/Detail.vue'),
        props: route => ({
          id: String(route.params.id)
        })
      },
      {
        path: 'about',
        name: 'ja/about',
        component: () => import('../views/About.vue'),
      },
      {
        path: 'link',
        name: 'ja/link',
        component: () => import('../views/Links.vue'),
      },
      {
        path: 'sitemap',
        name: 'ja/sitemap',
        component: () => import('../views/Sitemap.vue'),
      },
    ]
  },
  {
    path: '/en',
    component: () => import('../views/En.vue'),
    children: [
      {
        path: '',
        name: 'en/home',
        component: Home,
      },
      {
        path: 'index/:id',
        name: 'en/index_sub',
        component: () => import('../views/Index.vue'),
        props: route => ({
          id: String(route.params.id)
        })
      },
      {
        path: 'search',
        name: 'en/search',
        component: () => import('../views/Search.vue'),
      },
      {
        path: 'detail/:id',
        name: 'en/detail',
        component: () => import('../views/Detail.vue'),
        props: route => ({
          id: String(route.params.id)
        })
      },
      {
        path: 'about',
        name: 'en/about',
        component: () => import('../views/About_en.vue'),
      },
      {
        path: 'link',
        name: 'en/link',
        component: () => import('../views/Links_en.vue'),
      },
      {
        path: 'sitemap',
        name: 'en/sitemap',
        component: () => import('../views/Sitemap_en.vue'),
      },
    ]
  },
  {
    path: '*',
    name: 'notFound',
    redirect: '/',
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.path != '/search/' && from.path != '/en/search/') {
        return { x: 0, y: 0 }
      }
    }
  }
})

export default router
